var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLukka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.59 102.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#111a44;}.cls-2{fill:#2aace2;}.cls-3{fill:#f89938;}.cls-4{font-size:12px;font-family:Montserrat-Medium, Montserrat;font-weight:500;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.43,
    cy: 72.01,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.43,
    cy: 93.12,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.43,
    cy: 50.9,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.79,
    cy: 40.34,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.79,
    cy: 82.57,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.79,
    cy: 61.45,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.15,
    cy: 50.9,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.15,
    cy: 29.79,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.15,
    cy: 72.01,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.43,
    cy: 8.68,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.72,
    cy: 50.9,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.72,
    cy: 29.79,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 82.72,
    cy: 72.01,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64.08,
    cy: 19.23,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 45.43,
    cy: 29.79,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.79,
    cy: 19.23,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64.08,
    cy: 40.34,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64.08,
    cy: 82.57,
    r: 8.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64.08,
    cy: 61.45,
    r: 8.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "365.44 101.24 381.24 101.24 350.07 63.05 379.27 24.69 363.46 24.69 331.36 67.14 331.36 0 319.02 0 319.02 101.24 331.36 101.24 331.36 87.62 342.39 73.14 365.44 101.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "297.78 101.24 313.59 101.24 282.41 63.05 311.61 24.69 295.81 24.69 263.71 67.14 263.71 0 251.36 0 251.36 101.24 263.71 101.24 263.71 87.62 274.74 73.14 297.78 101.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "125.43 89.88 125.43 0 113.09 0 113.09 89.88 113.09 101.24 125.43 101.24 167.41 101.24 167.41 89.88 125.43 89.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.18,24.69V69.38A21.49,21.49,0,0,1,204.7,90.87h0a21.49,21.49,0,0,1-21.49-21.49V24.69H170.87V70.62h0c0,.49,0,1,0,1.48,0,16.91,15.14,30.62,33.83,30.62a36,36,0,0,0,21.48-7v5.49h12.34V24.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445,24.69V35.15a39.76,39.76,0,1,0,0,55.63v10.46h12.34V24.69Zm-28.4,66.67A28.4,28.4,0,1,1,445,63,28.39,28.39,0,0,1,416.55,91.36Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(463.08 32.19)"
  }, "TM")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLukka);
export default __webpack_public_path__ + "static/media/lukka.1002e03dfae456440b3fee6f8658bde0.svg";
export { ForwardRef as ReactComponent };